import { Formik, Form } from 'formik'

import { TimeRangeEnum } from '@interfaces/TimeRangeEnum'
import { Button } from '@components/Button'
import { SelectButtonField } from '@components/forms/SelectButtonField'
import { DateTimeInputField } from '@components/forms/DateTimeInputField'
import { usePermissionAction } from '@hooks/permission/usePermissionAction'
import { ByTitleFormProps } from './interface'
import { SearchBookField } from '../SearchBookField'

export function ByTitleForm({
  initialValues,
  text,
  handleSubmit,
  setText,
  resetHandler,
}: ByTitleFormProps) {
  const permission = usePermissionAction('dashboard')

  const timeRangeOption = [
    { value: TimeRangeEnum.DAY, text: 'เมื่อวาน' },
    { value: TimeRangeEnum.MONTH, text: '1 เดือน' },
    { value: TimeRangeEnum.YEAR, text: '1 ปี' },
  ]
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, isSubmitting, setFieldValue }) => (
          <Form>
            <div className='flex flex-col gap-y-[20px] mb-[30px]'>
              <div className='grid grid-cols-1'>
                <SearchBookField
                  name='bookId'
                  text={text}
                  setText={setText}
                  placeholder='ค้นหาด้วยชื่อเรื่อง หรือ ID'
                  inputClassName='font-[300] bg-gray-50 rounded-[20px]'
                  className='mt-[22px]'
                  resetHandler={() => {
                    resetHandler()
                  }}
                />
              </div>
              <div className='flex justify-between items-end '>
                <div className='flex items-end gap-x-[10px]'>
                  <SelectButtonField
                    name='timeRange'
                    options={timeRangeOption}
                    label='เลือกช่วงเวลา'
                    mode='line'
                    className='w-fit overflow-auto'
                    onChange={() => {
                      if (values.startAt) {
                        setFieldValue('startAt', undefined)
                      }
                      if (values.endAt) {
                        setFieldValue('endAt', undefined)
                      }
                    }}
                  />
                  <DateTimeInputField
                    className='w-[180px]'
                    name='startAt'
                    placeholder='ตั้งแต่วันที่'
                    onChange={value => {
                      setFieldValue('startAt', value)
                      if (values.timeRange) {
                        setFieldValue('timeRange', undefined)
                      }
                    }}
                    maxDate={values.endAt || new Date()}
                  />
                  <DateTimeInputField
                    className='w-[180px] '
                    name='endAt'
                    placeholder='ถึงวันที่'
                    onChange={value => {
                      setFieldValue('endAt', value)
                      if (values.timeRange) {
                        setFieldValue('timeRange', undefined)
                      }
                    }}
                    minDate={values.startAt}
                    maxDate={new Date()}
                  />
                </div>
                <div className='flex font-mitr justify-end ml-[25px] gap-x-[20px]'>
                  <Button
                    type='reset'
                    className='text-secondary underline'
                    onClick={() => {
                      resetHandler()
                    }}
                  >
                    <span className='text-[14px]'>ล้างค่า</span>
                  </Button>
                  <Button
                    type='submit'
                    className='bg-secondary text-white '
                    disabled={isSubmitting}
                  >
                    <span className='text-[14px]'>ค้นหา</span>
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
